import { gql } from '@apollo/client'

export const GET_STORE_SIMPLE = gql`
  query GetStoreSimple($id: ID!) {
    store(id: $id) {
      id
      location {
        id
        name
      }
    }
  }
`
